import { isEmpty, startCase } from 'lodash'
import { bulletSection } from '../helper'

export default [
  {
    generate({ answers, simplified }) {
      const treatmentQuestionsKeys = ['10', '11', '13', '14', '15', '16', '19', '20']
      const filteredTreatmentQuestionKeys = treatmentQuestionsKeys.filter((key) => !isEmpty(answers[key]))

      const previous = []
      const actual = []

      for (const key of filteredTreatmentQuestionKeys) {
        for (const [medicine, answer] of Object.entries(answers[key])) {
          const title = startCase(medicine).replace(' ', ' + ')

          if (simplified) {
            switch (answer.simplePeriod) {
              case 'current':
                actual.push(title)
              case 'previous':
                previous.push(title)
            }
            continue
          }

          if (answer.fullPeriod.endDate) {
            previous.push(title)
          } else {
            actual.push(title)
          }
        }
      }

      const sections = []

      if (previous.length) {
        sections.push(bulletSection('Realizou os seguintes tratamentos prévios:', previous))
      }

      if (actual.length) {
        sections.push(bulletSection('Atualmente em uso de:', actual))
      }

      return sections
    },
    version: {
      /** @type {number[]} */
      include: [],
      /** @type {number[]} */
      exclude: [],
    },
  },
]
